import { render, staticRenderFns } from "./MerchantInfo.vue?vue&type=template&id=12055d7e&scoped=true&"
import script from "./MerchantInfo.vue?vue&type=script&lang=js&"
export * from "./MerchantInfo.vue?vue&type=script&lang=js&"
import style0 from "./MerchantInfo.vue?vue&type=style&index=0&id=12055d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12055d7e",
  null
  
)

export default component.exports